import { withStyles } from '@material-ui/core/styles';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import styled from 'styled-components';
/*
  ## Assistente de etapas (Stepper, Step) ##
*/

export const Container = styled.div`
  width: 100%;
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLOR.GREEN_1};
`;

export const BoxStepper = styled.div`
  width: 100%;
  max-width: 616px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding: 24px 18px 18px 18px;
`;

export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 99px;
    height: 28px;
  }
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    span {
      font-size: 20px;
    }
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    span {
      font-size: 22px;
    }
  }
`;

export const StyledStepper = withStyles(() => ({
  root: {
    margin: '14px auto 0 auto',
    padding: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '350px',
    backgroundColor: 'transparent',
  },
}))(Stepper);

export const StyledStep = withStyles(() => ({
  root: {
    '& .MuiStepLabel-labelContainer': {
      display: 'none',
    },
    '& .MuiStepIcon-text': {
      fill: `${COLOR.GREEN_1}`,
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontSize: '12px',
    },
    '& .MuiStepIcon-root': {
      color: '#F5FAF9',
      width: '28px',
      height: '28px',
      '& .MuiStepIcon-text': {
        fill: `${COLOR.GREY_2}`,
      },
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#F5FAF9',
    },
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: '#F5FAF9',
      textDecoration: 'underline',
      '& .MuiStepIcon-text': {
        fill: `${COLOR.GREEN_1}`,
      },
    },
    '& .MuiStepConnector-lineHorizontal': {
      borderTopStyle: 'dotted',
      borderTopWidth: '5px',
      borderColor: `${COLOR.WHITE_1}`,
    },
  },
}))(Step);
